module.exports = __webpack_public_path__ + "static/media/paco-rabanne-invictus-big.27ae6f18.png";